(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();

      this.generateMarkup()
    }

    async generateMarkup() {
      if(window.location.pathname.includes('/products/')) {
        this.currentProductHandle = window.location.pathname.split('/products/')[1].split('/')[0]
        this.recentlyViewedHandles = Array.from(
          window.localStorage.getItem('recently-viewed') ?
            window.localStorage.getItem('recently-viewed').split(',')
            : false
        )

        this.parentWrapper = document.querySelector('.product-recently-viewed-wrapper')
        this.productsWrapper = document.getElementById('recently-viewed')
        this.recentlyViewedMarkup = ''
        this.recentlyViewedMarkupHandles = []

        for(let i = 0; i < this.recentlyViewedHandles.length; i += 1) {
          if(
            this.recentlyViewedMarkupHandles.length < 4
            && this.recentlyViewedMarkupHandles.indexOf(this.recentlyViewedHandles[i]) <= -1
            && this.currentProductHandle != this.recentlyViewedHandles[i]
          ) {
            await fetch(`${this.recentlyViewedHandles[i]}/?view=product-card`)
              .then(res => res.text())
              .then(res => {
                if (!res.includes("404 Not Found") ) {
                  this.recentlyViewedMarkupHandles.push(this.recentlyViewedHandles[i])
                  this.recentlyViewedMarkup += `${res}`
                }
              })
          }
        }

        this.recentlyViewedHandles.unshift(this.currentProductHandle)

        if(this.recentlyViewedMarkup != '') {
          this.productsWrapper.innerHTML = this.recentlyViewedMarkup

          new SimpleBar(this.productsWrapper, {
            autoHide: false,
            forceVisible: true
          })
        } else {
          this.parentWrapper.style.display = 'none'
        }

        window.localStorage.setItem('recently-viewed', this.recentlyViewedHandles)
      }
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);

  } catch(e) { console.error(e); }
})();
})();
